<template>
  <div class="proposal-source-cell">
    {{ displayValue }}
  </div>
</template>

<script>
export default {
  name: "ProposalSourceCell",
  props: {
    value: [String, Number, Object],
    row: Object,
    column: Object,
  },
  computed: {
    displayValue() {
      try {
        if (!this.value) return "-";
        const url = new URL(this.value);
        return url.host;
      } catch {
        return this.value ?? "-";
      }
    },
  },
};
</script>

<style scoped lang="less"></style>
